// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3u-1";
export var movingGradient = "_3u-4";
export var movingGradientBlock = "_3u-2";
export var skeleton = "_3u-0";
export var skeletonText = "_3u-3";